import React, { useState } from "react";

import "./set_new_password.css";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import KeyIcon from "@mui/icons-material/Key";
import HelpIcon from "@mui/icons-material/Help";
import { IconButton } from "@mui/material";
import logo from "../../images/PPKM_Head.png";
import getEventController from "../Member/Controller/getEvent_controller";

const SetNewPasswordAndPin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, userID, companyName, memberId } = location.state; // Access passed data
  console.log(email);
  console.log(userID);
  console.log(companyName);
  console.log(memberId);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const [RetypePassword, setRetypePassword] = useState("");
  const [showNewPin, setShowNewPin] = useState(false);
  const [NewPin, setNewPin] = useState("");
  const [showRetypeNewPin, setShowRetypeNewPin] = useState(false);
  const [RetypeNewPin, setRetypeNewPin] = useState("");
  const [passwordError, setPasswordError] = useState(null);
  const [pinError, setPinError] = useState(null);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleRetypePasswordVisibility = () => {
    setShowRetypePassword((prev) => !prev);
  };
  const toggleNewPinVisibility = () => {
    setShowNewPin((prev) => !prev);
  };
  const toggleRetypeNewPinVisibility = () => {
    setShowRetypeNewPin((prev) => !prev);
  };

  const handleSetNewPassword = async (e) => {
    e.preventDefault();
    setPasswordError(null); // Reset password error
    setPinError(null); // Reset pin error

    let hasError = false;

    // Check if Password and RetypePassword match
    if (password !== RetypePassword) {
      setPasswordError("Password and Retype Password do not match.");
      hasError = true;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!passwordRegex.test(password)) {
      setPasswordError(
        "Password must be at least 8 characters long and include uppercase, lowercase, and numbers only."
      );
    } else {
      hasError = false;
      // setError(null); // Clear error if valid
    }

    // Check if NewPin and RetypeNewPin match
    if (NewPin !== RetypeNewPin) {
      setPinError("New Pin and Retype New Pin do not match.");
      hasError = true;
    }

    // If any errors exist, stop execution
    if (hasError) return;

    console.log(userID);
    console.log(password);
    console.log(RetypePassword);
    console.log(NewPin);
    console.log(RetypeNewPin);

    // Call the authentication function
    const data = await getEventController.UpdatePasswordAndPin(
      userID,
      password,
      NewPin
    );

    console.log(data);

    if (data.success == "true") {
      // If successful, navigate to the next page, e.g., OTP page or dashboard
      navigate("/dashboard");
      // console.log(data);
    } else {
      alert("Setup Failed. Please try again.");
    }
  };
  return (
    <div className="set-password-page">
      <div className="d-flex set-password-container">
        <div className="set-password-wrapper">
          <div className="login-title">
            <img className="sp-web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="pa-title_para">PASSWORD SETUP</p>
          {/* <p className="re-span">
            You've selected to login.
            <br /> Kindly enter the correct password to login.
          </p> */}
          <div className="mt-2">
            <label className="form-label pa-form-label">
              Password Setup For
            </label>
            <div className="set-account-info-block">
              <span className="set-account-info-lbl">{companyName}</span>
              <span className="set-account-info-lbl2">
                Membership No.: {memberId}
              </span>
            </div>
          </div>
          <div>
            <label className="form-label sp-alert-lbl">
              Password must be at least 8 characters long and include uppercase,
              lowercase, and numbers only.
            </label>
          </div>
          <form className="set-password-form" onSubmit={handleSetNewPassword}>
            {/* New Password */}
            <div className="set-password-row">
              <label className="form-label sp-lbl">
                New Password <HelpIcon className="set-sp-info-icon" />
              </label>
              <div className="pa-row">
                {/* password */}
                <LockIcon className="set-sp-form-logo" />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="New Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <IconButton
                  onClick={togglePasswordVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </div>
            </div>
            {/* New Retype Password */}
            <div className="set-password-row">
              <label className="form-label sp-lbl">Retype Password</label>
              <div className="pa-row">
                {/* password */}
                <LockIcon className="set-sp-form-logo" />
                <input
                  type={showRetypePassword ? "text" : "password"}
                  placeholder="Retype Password"
                  required
                  value={RetypePassword}
                  onChange={(e) => setRetypePassword(e.target.value)}
                />
                <IconButton
                  onClick={toggleRetypePasswordVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showRetypePassword ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </IconButton>
              </div>
            </div>
            {passwordError && <p style={{ color: "red" }}>{passwordError}</p>}
            {/* New Pin */}
            <div className="set-password-row">
              <label className="form-label sp-lbl">
                New 6-Digits Pin <HelpIcon className="set-sp-info-icon" />
              </label>
              <div className="pa-row">
                {/* password */}
                <KeyIcon className="set-sp-form-logo" />
                <input
                  type={showNewPin ? "text" : "password"}
                  placeholder="New Pin"
                  required
                  value={NewPin}
                  onChange={(e) => {
                    // Restrict input to numbers and limit length to 6
                    const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                    if (numericValue.length <= 6) {
                      setNewPin(numericValue);
                    }
                  }}
                />
                <IconButton
                  onClick={toggleNewPinVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showNewPin ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </div>
            </div>
            {/* New Retype Pin */}
            <div className="set-password-row">
              <label className="form-label sp-lbl">Retype 6-Digits Pin</label>
              <div className="pa-row">
                {/* password */}
                <KeyIcon className="set-sp-form-logo" />
                <input
                  type={showRetypeNewPin ? "text" : "password"}
                  placeholder="Retype Pin"
                  required
                  value={RetypeNewPin}
                  onChange={(e) => {
                    // Restrict input to numbers and limit length to 6
                    const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                    if (numericValue.length <= 6) {
                      setRetypeNewPin(numericValue);
                    }
                  }}
                />
                <IconButton
                  onClick={toggleRetypeNewPinVisibility}
                  sx={{
                    padding: 0,
                  }}
                >
                  {showRetypeNewPin ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </IconButton>
              </div>
            </div>
            {pinError && <p style={{ color: "red" }}>{pinError}</p>}

            <div className="reset-button-row">
              <Button className="reset-button" type="submit">
                Save
              </Button>
            </div>
            <div className="sp-back-button-row">
              <a
                className="sp-back-button"
                onClick={() =>
                  navigate("/membership_selection", { state: { email } })
                }
              >
                Back
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SetNewPasswordAndPin;
